import styles from "./talentwerk.module.css";
import { useEffect, useState } from "react";
import PersonCard from "../../../../components/PersonCard/PersonCard";
import InfoTabelle from "../../../../components/InfoTabelle/InfoTabelle"
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { loadAssignmentsByArea } from "../../../../../code/AssignmentPersons";
import Bildergalerie from "../../../../components/Bildergalerie/Bildergalerie";
function Talentwerk() {
    const [ansprechpartnerPerson, setAnsprechpartnerPerson] = useState(null);
    const [persons, setPersons] = useState([]);
    const color = '--color-red';
    const colorText = '--main-color-white';

    useEffect(() => {
        loadAssignmentsByArea(11, setAnsprechpartnerPerson, color, colorText, true);
        loadAssignmentsByArea(12, setPersons, color, colorText);
    }, []);
    const images_wertesystem = [
        { "path": "/images/mannschaftssport/talentwerk/wertesystem_trainer.jpg" },

        { "path": "/images/mannschaftssport/talentwerk/wertesystem_spieler.jpg" },
        {
            "path": "/images/mannschaftssport/talentwerk/wertesystem_eltern.jpg"
        },
    ]
    const images_mannschaft = [
        { "path": "/images/mannschaftssport/talentwerk/einbettung.jpg" },
        { "path": "/images/mannschaftssport/talentwerk/mannschaftsstrukturen.jpg" },
    ]
    const images_ausstattung = [
        { "path": "/images/mannschaftssport/talentwerk/spielerausstattuungen.jpg" },

    ]

    const tabs = [
        {
            title: "Systematisches Training",
            content: ["Die Ausbildung der Talente folgt einem systematisch ausgearbeitetem Trainingskonzept, welches darauf ausgerichtet ist, altersgerechte und jahrgangsspezifische Schwerpunkte zu vermitteln.",
                "Dabei wird zwischen Grundlagen-, Aufbau-und Leistungsbereich unterschieden. Einen hohen Stellenwert in den Trainingsinhalten nimmt das Fordern und Fördern von Individualität jedes/jeder Spielers/Spielerin ein. Gleichsam ist man sich bewusst darüber, dass sportlicher Erfolg nur als Einheit zustande kommt und diesem eine gute Mannschafts-, Gruppen- und Individualtaktische Ausbildung zugrunde liegen muss.",
                "Beides soll in den Trainingsinhalten, neben der Entwicklung von koordinativen Fähigkeiten und der fußballspezifischen Technikschulung, gut ausbalanciert vermittelt werden. Die ganzheitliche Ausbildung der Talente hat gemeinsam mit der Freude am Fußball, oberste Priorität in der Trainingsgestaltung."
            ],
        },
        {
            title: "Lizensierte Trainer:innen",
            content: ["Vermittelt werden diese Inhalten von lizensierten Trainer*innen, sodass sichergestellt werden kann, dass die Trainingsinhalte fachmännisch weitergegeben werden.",
                "Unterstützt wird das Mannschaftstrainer*innen-Team von Spezialtrainer*innen in den Bereichen Athletik und Technik, sowie einem Torwarttrainer.",
                "Ein wesentlicher Baustein der Ausbildung ist also Spezialtraining, welches zusätzlich zum Mannschaftstraining umgesetzt wird. Auch in diesen Bereichen wird mit lizensierten Trainer*innen zusammengearbeitet, um die Inhalte optimal weiterzugeben."
            ],
        },
        {
            title: "Vermittlung eines Wertesystems",
            content: ["Die dritte Säule baut auf der Vermittlung eines Wertesystems auf.",
                "„Wir sind uns als Fußballverein und insbesondere in der Jugendabteilung, unserer sozialen Funktion absolut bewusst und sehen in jedem Spieler und jeder Spielerin vordergründig den Menschen“, so der sportliche Leiter Tim Görgens.",
                "„Wir nehmen uns der Aufgabe, Werte des sozialen Miteinanders zu vermitteln, verantwortungsbewusst an und messen dieser Aufgabe eine große Wichtigkeit in der Ausbildung unserer Talente bei.“"
            ],
        },
        {
            title: "Entwicklung der Persönlichkeiten",
            content: ["Außerdem ist man der Überzeugung, dass die ersten drei Säulen auf eine positive Entwicklung der Persönlichkeit der Talente auf und neben dem Fußballplatz abzielt.",
                "Es sollen Werte des Leistungsprinzips ebenso wie Werte des sozialen Miteinanders vermittelt und jeden Tag vorgelebt werden.",
                "„Wir vermitteln Verantwortungsbewusstsein und Gemeinschaft und dass Erfolg ein Ergebnis aus all den erwähnten Bausteinen ist und hoffen so, eine ganzheitliche Ausbildung der jungen Menschen, für die wir Verantwortung übernehmen, anbieten zu können.“"
            ],
        },
    ];
    const handleErimaClick = () => {
        window.open("https://erima.shop/tus-05-oberpleis", "_blank");
    }

    return (
        <section className={styles.container}>
            <h1>Infos zum Talentwerk</h1>
            <section className={styles.section}>
                <h2>Ansprechpartner</h2>
                <div className={styles.ansprechpartnerInfo}>
                    <div className={styles.person}>
                        {ansprechpartnerPerson && <PersonCard person={ansprechpartnerPerson} />}
                    </div>
                    <div className={styles.infoText}>
                        <p>Die Jugendfußballschule des TUS 05 Oberpleis stellt sich zur Saison 2023/24 neu auf und möchte mit Konstanz und einem klaren Konzept an die Gründungsidee anschließen und die leistungsorientierte Jugend- und Talentförderung am Standort Oberpleis wieder in den Mittelpunkt rücken.</p>
                        <p>Vergangenen Dezember ist Tim Görgens als sportlicher Leiter des Talentwerks installiert worden. Das Projekt startete zur Saison 2018/19 und wurde ins Leben gerufen, um neben den weiterhin bestehenden Breitensport-Mannschaften, eine gezielte Talentförderung unter Leistungsprinzipien anzubieten.</p>
                        <p>Die 1. Herrenmannschaft des TuS 05 Oberpleis ist seit Jahren in der Landesliga etabliert, sodass es absolut notwendig ist im Nachwuchsbereich leistungsorientiert zu arbeiten, um wieder mehr eigene Talente hervorzubringen.</p>
                    </div>
                </div>
            </section>
            <section className={styles.section}>
                <h2>Die Talentwerk-Philosophie (4 Säulen)</h2>
                <div>
                    <InfoTabelle tabs={tabs} />
                </div>
            </section>
            <section id="wertesystem" className={styles.section}>
                <h2>Wertesystem für Trainer*innen, Spieler*innen und Eltern</h2>
                <div>
                    <Bildergalerie images={images_wertesystem} />
                </div>
            </section>
            <section id="einbettung-und-mannschaftsstrukturen" className={styles.section}>
                <h2>Einbettung und Mannschaftsstrukturen</h2>
                <Bildergalerie images={images_mannschaft} />
            </section>
            <section id="ausstattungen-der-spielerinnen" className={styles.section}>
                <h2>Ausstattung der Spieler*innen</h2>
                <div className={styles.columnDiv}>
                    <Bildergalerie images={images_ausstattung} />
                    <div className={styles.erima}>
                        <img
                            tabIndex={0}
                            className={styles.erimaImg}
                            src={`${process.env.PUBLIC_URL}/images/shop/erima_logo_2024.svg`}
                            alt="Erima Logo"
                            onClick={handleErimaClick}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {

                                    e.preventDefault(); // Prevent space from scrolling
                                    handleErimaClick()
                                }
                            }}
                            style={{ cursor: "pointer" }} />
                        <p>
                            Mehr zu finden bei unserem Partner: <span tabIndex={0} className={styles.erimaLink} onClick={handleErimaClick}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {

                                        e.preventDefault(); // Prevent space from scrolling
                                        handleErimaClick()
                                    }
                                }}
                            >Erima</span>
                        </p>
                        <img
                            tabIndex={0}
                            className={styles.erimaImg}
                            src={`${process.env.PUBLIC_URL}/images/shop/erima_logo_2024.svg`}
                            alt="Erima Logo"
                            onClick={handleErimaClick}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {

                                    e.preventDefault(); // Prevent space from scrolling
                                    handleErimaClick()
                                }
                            }}
                            style={{ cursor: "pointer" }} />

                    </div>
                </div>
            </section>
            <section id="verantwortlichkeiten" className={styles.section}>
                <h2>Verantwortlichkeiten</h2>
                <div className={styles.personenDiv}>
                    {persons.map((person) => (<PersonCard person={person} />))}
                    {/* 
                    {<PersonCard person={lucasKern} />}
                    {<PersonCard person={patrickRueth} />} */
                    }

                </div>
            </section>
        </section>
    );
}

export default Talentwerk;